import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={12} className="home-header">
              <div className="home-intro">
                <h1 className="heading">
                  Hey There!
                </h1>

                <h1 className="heading-name">
                  I'm
                  <b className="main-name"> Jayson Gonzalez</b>
                </h1>

                <div className="type-wrap">
                  <Type />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
